// @ts-nocheck
import {Percent, CurrencyUSD, Time, GraphQLDecimal} from '@/graphql/scalars'

import * as Types from '../../../../types/schema';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type MergeEntityMutationVariables = Types.Exact<{
  input: Types.MergeEntitiesInput;
}>;


export type MergeEntityMutation = { __typename?: 'Mutation', mergeEntities: { __typename?: 'Entity', id: string } };

export const Operations = {
  Mutation: {
    MergeEntity: 'MergeEntity' as const
  }
}

/**
 * Custom plugin to wrap useQuery hooks with automatic context.fetchPolicy injection
 */
function withFetchPolicyContext(options) {
  const fetchPolicy = options?.fetchPolicy ?? 'cache-first';
  const isLazy = options?.isLazy ?? undefined;
  return {
    ...options,
    context: {
      ...options?.context,
      fetchPolicy,
      isLazy,
    },
  };
}

/**
 * Defaults useSubscription to ignoreResults: true so Apollo skips its
 * per-message useSyncExternalStore notification (forceStoreRerender). All
 * call sites manage state via onData; opting out avoids render storms when
 * messages arrive in a synchronous burst. See T2-10011. Callers that need
 * Apollo to surface data/loading/error can override by passing
 * ignoreResults: false explicitly.
 */
function withSubscriptionIgnoreResults(options) {
  return {
    ignoreResults: true,
    ...options,
  };
}


export const MergeEntityDocument = gql`
    mutation MergeEntity($input: MergeEntitiesInput!) {
  mergeEntities(input: $input) {
    id
  }
}
    `;
export type MergeEntityMutationFn = Apollo.MutationFunction<MergeEntityMutation, MergeEntityMutationVariables>;

/**
 * __useMergeEntityMutation__
 *
 * To run a mutation, you first call `useMergeEntityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMergeEntityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [mergeEntityMutation, { data, loading, error }] = useMergeEntityMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useMergeEntityMutation(baseOptions?: Apollo.MutationHookOptions<MergeEntityMutation, MergeEntityMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MergeEntityMutation, MergeEntityMutationVariables>(MergeEntityDocument, options);
      }
export type MergeEntityMutationHookResult = ReturnType<typeof useMergeEntityMutation>;
export type MergeEntityMutationResult = Apollo.MutationResult<MergeEntityMutation>;
export type MergeEntityMutationOptions = Apollo.BaseMutationOptions<MergeEntityMutation, MergeEntityMutationVariables>;